var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreencardnotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28C33.5228 0 38 4.47715 38 10V28C38 33.5228 33.5228 38 28 38H10C4.47715 38 0 33.5228 0 28V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 23.5001H21.2502M17.5002 25.7501H20.5002M19.0002 12.2501C18.0841 12.2453 17.1884 12.5201 16.4328 13.038C15.6771 13.5558 15.0975 14.292 14.7714 15.148C14.4453 16.0041 14.3882 16.9393 14.6077 17.8286C14.8273 18.718 15.3131 19.5192 16.0002 20.1251C16.4502 20.5751 16.7502 21.1751 16.7502 22.0001H21.2502C21.2502 21.1751 21.5502 20.5751 22.0002 20.1251C22.6872 19.5192 23.173 18.718 23.3926 17.8286C23.6122 16.9393 23.5551 16.0041 23.229 15.148C22.9028 14.292 22.3232 13.5558 21.5676 13.038C20.8119 12.5201 19.9162 12.2453 19.0002 12.2501Z",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#1FA765"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencardnotification);
export default __webpack_public_path__ + "static/media/green card notification.b209bc679d2a8e9f751b31e101ba746e.svg";
export { ForwardRef as ReactComponent };